import { createContext } from 'react'
import type { UserResponse } from '@/types/api/responses'

export interface AuthContextType {
  user: UserResponse | null
  loading: boolean
  isSigningUp: boolean
  signOut: () => Promise<void>
  login: (email: string, password: string) => Promise<string | undefined>
  signup: (email: string, password: string, fullName: string) => Promise<string>
  refreshUser: () => Promise<void>
}

export const AuthContext = createContext<AuthContextType | undefined>(undefined)
